
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/components/modules-and-containers",
      function () {
        return require("private-next-pages/design-system/components/modules-and-containers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/components/modules-and-containers"])
      });
    }
  